import React from 'react'
import styles from "../Components/styles/Contribute.module.css"

const About = () => {
    return (
        <div className = {styles.about}>
            <ul>
                <li>Company name is easyshopcart</li>
                <li> Company was established on May 15, 2021.</li>
                <li>Rajat Sahu is the CEO, CTO, and CMO of the company.</li>
                <li>This is e-commerce website.</li>
                <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus odio accusamus 
                    officia neque sapiente magni odit, qui dicta provident error dolorem libero vero possimus 
                    ea itaque,exercitationem doloremque eaque incidunt! 
                </li>
                <li>Lorem ipsum dolor sit amet consectetur adipisicing elit. Necessitatibus odio accusamus </li>
                <li>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aliquam, nihil saepe vero eius </li>
                <li>Dolorem libero vero possimus ea itaque,exercitationem doloremque eaque incidunt! </li>
                <li>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Aliquam, nihil saepe vero eius 
                    molestias minima! Doloribus sequi voluptatem incidunt dignissimos sed quasi provident odio 
                    et perferendis ex, quas explicabo natus.
                </li>
            </ul>
        </div>
    )
}

export { About }
